"use client";

import { c as _c } from "react/compiler-runtime";
import { UserCheck, UserPlus } from "lucide-react";
import { FIELD_CLASSNAME } from "@/src/components/online-scheduling/types";
import { Label } from "@/src/components/shadcn/ui/label";
import { Textarea } from "@/src/components/shadcn/ui/textarea";
import { ToggleGroup, ToggleGroupItem } from "@/src/components/shadcn/ui/toggle-group";
import { Muted } from "@/src/components/typography";
import { cn } from "@/src/lib/shadcn-utils";
const OPTION_CLASSNAME = cn(FIELD_CLASSNAME, "h-auto w-full justify-start gap-2 px-4 py-4");
export function VisitStep(t0) {
  const $ = _c(22);
  const {
    isReturningPatient,
    onChangeReturning,
    reasonForVisit,
    onChangeReason,
    brandName
  } = t0;
  const t1 = brandName ?? "us";
  let t2;
  if ($[0] !== t1) {
    t2 = <Label id="patient-type-label">Have you visited {t1} before?</Label>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isReturningPatient ? "returning" : "new";
  let t4;
  if ($[2] !== onChangeReturning) {
    t4 = value => {
      if (value) {
        onChangeReturning(value === "returning");
      }
    };
    $[2] = onChangeReturning;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ToggleGroupItem value="new" className={OPTION_CLASSNAME}><UserPlus />I'm a new patient</ToggleGroupItem>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ToggleGroupItem value="returning" className={OPTION_CLASSNAME}><UserCheck />I'm a returning patient</ToggleGroupItem>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t3 || $[7] !== t4) {
    t7 = <ToggleGroup type="single" variant="outline" aria-labelledby="patient-type-label" value={t3} onValueChange={t4} className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2">{t5}{t6}</ToggleGroup>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t2 || $[10] !== t7) {
    t8 = <div className="space-y-2">{t2}{t7}</div>;
    $[9] = t2;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Label htmlFor="reason-for-visit">What brings you in? <span className="font-normal text-muted-foreground">(optional)</span></Label>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== onChangeReason) {
    t10 = event => onChangeReason(event.target.value);
    $[13] = onChangeReason;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== reasonForVisit || $[16] !== t10) {
    t11 = <div className="space-y-2">{t9}<Textarea id="reason-for-visit" value={reasonForVisit} onChange={t10} placeholder={"Briefly describe the reason for your visit\u2026"} rows={3} maxLength={200} className={FIELD_CLASSNAME} /></div>;
    $[15] = reasonForVisit;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Muted className="block">For a medical emergency, call 911.</Muted>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t8) {
    t13 = <div className="space-y-6">{t8}{t11}{t12}</div>;
    $[19] = t11;
    $[20] = t8;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
}